import * as actions from "../../../actions/indication/report";

const initialState = {
  loading: false,
  items: []
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.CLEAR_ITEMS: {
      return {
        ...state,
        items: [],
        loading: true
      };
    }
    case actions.GET_INDICATIONS: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_INDICATIONS_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.GET_INDICATIONS_SUCCESS: {
      return {
        ...state,
        items: payload ? payload : [],
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
